export default __webpack_public_path__ + "media/images/lp/icon3-43e9b26917e15b0507f4432ce9470ba0.png";